import { Component } from '@angular/core';

@Component({
  selector: 'portfolio-skeleton',
  templateUrl: './portfolio-skeleton.component.html',
  styleUrl: './portfolio-skeleton.component.scss'
})
export class PortfolioSkeletonComponent {}
